__turbopack_context__.v({
  "error": "ContactForm-module__TIbd0G__error",
  "form": "ContactForm-module__TIbd0G__form",
  "formIntro": "ContactForm-module__TIbd0G__formIntro",
  "honeypot": "ContactForm-module__TIbd0G__honeypot",
  "kicker": "ContactForm-module__TIbd0G__kicker",
  "nameRow": "ContactForm-module__TIbd0G__nameRow",
  "privacy": "ContactForm-module__TIbd0G__privacy",
  "resetButton": "ContactForm-module__TIbd0G__resetButton",
  "submitButton": "ContactForm-module__TIbd0G__submitButton",
  "successCard": "ContactForm-module__TIbd0G__successCard",
});
